import type { Comic } from "@/types/comic";
import { comics } from "@/mocks/comics";

export interface Chapter {
  id: string;
  index: number;
  title: string;
  updatedAt: string;
}

export function getChapters(comic: Comic): Chapter[] {
  const list: Chapter[] = [];
  for (let i = comic.chapterCount; i >= 1; i -= 1) {
    const day = new Date(2026, 9, 15);
    day.setDate(day.getDate() - (comic.chapterCount - i));
    list.push({
      id: String(i),
      index: i,
      title: `第 ${i} 话`,
      updatedAt: day.toISOString().slice(0, 10),
    });
  }
  return list;
}

export function getComicById(id: string | undefined): Comic | undefined {
  if (!id) return undefined;
  return comics.find((c) => c.id === id);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return String(views);
}

export function filterByCategory(type: string | undefined): Comic[] {
  if (!type) return comics;
  if (type === "hot") {
    return [...comics].sort((a, b) => b.views - a.views);
  }
  if (type === "finished") {
    return comics.filter((c) => c.status === "完结");
  }
  const name = typeNameMap[type];
  if (!name) return comics;
  return comics.filter((c) => c.categories.includes(name));
}

export const typeNameMap: Record<string, string> = {
  romance: "爱情",
  fantasy: "奇幻",
  action: "动作",
  school: "校园",
  city: "都市",
  mystery: "悬疑",
  scifi: "科幻",
  hot: "热门",
  finished: "完结",
};

export const categorySlugMap: Record<string, string> = {
  爱情: "romance",
  奇幻: "fantasy",
  动作: "action",
  校园: "school",
  都市: "city",
  悬疑: "mystery",
  科幻: "scifi",
};

export const typeDescMap: Record<string, string> = {
  romance: "心动、守护与命运交织的浪漫故事，甜宠虐恋一网打尽。",
  fantasy: "魔法、异世界与冒险的奇幻旅程，想象力没有边界。",
  action: "热血战斗与快节奏对决，肾上腺素持续飙升。",
  school: "青春、友谊与初恋的校园日常，重返最闪亮的年纪。",
  city: "职场、财阀与都市人的情感与成长，贴近现实又上头。",
  mystery: "谜案、推理与反转不断，越看越停不下来的烧脑体验。",
  scifi: "机甲、末世与未来科技，探索人类想象的尽头。",
  hot: "按人气与阅读量排序，全站最受欢迎的韩漫榜单。",
  finished: "已经完结的韩漫合集，一次追到底。",
};

export function searchComics(keyword: string): Comic[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return comics.filter(
    (c) =>
      c.title.toLowerCase().includes(kw) ||
      c.author.toLowerCase().includes(kw) ||
      c.categories.some((cat) => cat.toLowerCase().includes(kw)) ||
      c.tags.some((t) => t.toLowerCase().includes(kw)),
  );
}

export function relatedComics(comic: Comic, limit = 6): Comic[] {
  const related = comics.filter(
    (c) =>
      c.id !== comic.id &&
      c.categories.some((cat) => comic.categories.includes(cat)),
  );
  const rest = comics.filter(
    (c) => c.id !== comic.id && !related.some((r) => r.id === c.id),
  );
  return [...related, ...rest].slice(0, limit);
}